import React from 'react';

import Typography from '@material-ui/core/Typography';

import { Actions, store } from '../../appredux'

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';


type DialogCopyToCartProps = {
  close: () => void,
  open: boolean
}

// mz 2022-03-29
class DialogCopyToCart extends React.Component<DialogCopyToCartProps, any> {

  copyToCart = () => {
    store.dispatch(Actions.pageState.cpyToCart(true));
    this.props.close()
  }

  render() {

    return (
      <Dialog
        disableEscapeKeyDown
        maxWidth="xs"
        open={this.props.open}
        fullWidth
      >
        <DialogTitle disableTypography>
          <Typography gutterBottom variant="h5" component="h2" color="primary" style={{ fontSize: "1.25rem" }}>
            <b>wybierz</b>
          </Typography>
          <hr style={{ marginTop: "10px" }} />
        </DialogTitle>

        <DialogContent >
          <DialogContentText gutterBottom variant="h5" component="h2">
            {"Dodać zawartość tego zamówienia do koszyka?"}
          </DialogContentText>
        </DialogContent >
        <DialogActions >
          <Button onClick={() => this.props.close()} variant="outlined" size="small" color="primary"
            style={{ textTransform: "none", fontSize: "0.8rem" }}
          >
            <b>nie</b> {/*<Trans>Back</Trans>*/}
          </Button>
          <Button onClick={() => this.copyToCart()} variant="contained" size="small" color="primary"
            style={{ textTransform: "none", fontSize: "0.8rem" }}
          >
            <b>tak</b>{/*<Trans>Next</Trans> */}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default DialogCopyToCart;